<template>
  <div
    v-for="data in ((leaveType == 'PanelGroup') ? panelData : 1)"
    :key="data"
    class="approval-leave-content"
    :class="{
      'leave-content-yellow' : (
        leaveType == 'Waiting' ||
        leaveType == 'ExpiringEmployee' ||
        leaveType == 'ExpiringDocument' ||
        leaveType == 'ExpiringAddition' ||
        leaveType == 'ExpiringCareer'
      ),
      'leave-content-green' : (
        leaveType == 'Approved' ||
        leaveType == 'ListLeaveToday' ||
        leaveType == 'PanelGroup'
      ),
      'leave-content-red' : (
        leaveType == 'Rejected' ||
        leaveType == 'ExpiredEmployee' ||
        leaveType == 'ExpiredDocument'||
        leaveType == 'ExpiredAddition' ||
        leaveType == 'ExpiredCareer'
      )
    }"
  >
    <div class="header-content">
      <p>{{
        ( leaveType == 'Waiting') ? 'Request - Waiting for Approval'
        : (leaveType == 'Approved') ? 'Request - Approved'
        : (leaveType == 'Rejected') ? 'Request - Rejected'
        : (leaveType == 'ExpiredEmployee') ? 'Expired Contract'
        : (leaveType == 'ExpiringEmployee') ? 'Expiring Contract'
        : (leaveType == 'ExpiredDocument') ? 'Expired Document'
        : (leaveType == 'ExpiringDocument') ? 'Expiring Document'
        : (leaveType == 'ExpiredAddition') ? 'Expired Leave'
        : (leaveType == 'ExpiringAddition') ? 'Expiring Leave'
        : (leaveType == 'ListLeaveToday') ? 'Today Leave'
        : (leaveType == 'ExpiredCareer') ? 'Expired Career'
        : (leaveType == 'ExpiringCareer') ? 'Expiring Career'
        : data.title ? data.title : ''
      }}</p>
    </div>

    <div
      v-if="!isLoading && (panelData.length != 0) && (leaveType != 'PanelGroup')"
      class="list-content"
      :class="{'list-content-full' : ['Waiting', 'ListLeaveToday'].includes(leaveType)}"
    >
      <div v-for="data in panelData" :key="data" class="list-outer" @click="openDetail(data)">
        <div class="list-inner-header">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 256 0 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 0 64 0 32 0zM96 75l0-11 192 0 0 11c0 19-5.6 37.4-16 53L112 128c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9L112 384z"/></svg>
          <p v-html="data.transaction_no" />
        </div>
        <p v-html="data.employee_name" class="list-inner-name" />
        <p v-html="data.info" class="list-inner-desc" />
        <p v-if="data.start_date" v-html="formatDate('timeline', data.start_date, (data.end_date ? data.end_date : null)) + (formatTime(data.start_time, data.end_time))" class="list-inner-date" />
      </div>
    </div>

    <div v-if="!isLoading && (panelDatafull.length != 0) && (leaveType != 'PanelGroup') && !['Waiting', 'ListLeaveToday'].includes(leaveType)" class="show-content">
      <div @click="openAll(leaveType, true, formatList(panelDatafull))" class="show-button">
        <p>Show All</p>
      </div>
    </div>

    <div
      v-if="!isLoading && (panelData.length == 0) && (leaveType != 'PanelGroup')"
      class="list-content"
      :class="{'list-content-full' : ['Waiting', 'ListLeaveToday'].includes(leaveType)}"
    >
      <div class="list-outer-none">
        {{ leaveData.length == 0 ? 'No data' : 'No request for approval of leave' }}
      </div>
    </div>

    <div v-if="isLoading && (leaveType != 'PanelGroup')" class="list-content">
      <div v-for="data in 3" :key="data" class="list-outer-load" />
    </div>

    <div v-if="!isLoading && (leaveType == 'PanelGroup')" class="group-content">
      <div
        v-for="child in data.child"
        :key="child"
        class="group-content-outer"
        :class="{
          'group-content-outer-yellow' : (child.color == 'yellow'),
          'group-content-outer-red' : (child.color == 'red')
        }"
      >
        <div class="content-outer-header">
          <p>{{ child.title }}</p>
        </div>

        <div class="content-outer-list">
          <div v-if="child.data.length == 0" class="content-inner-none">
            <p>No data!</p>
          </div>

          <div v-else v-for="list in child.data" :key="list" class="content-inner-list">
            <p>{{ list.employee_name }}</p>
            <p>{{ list.info }}</p>
            <p>{{ formatDate('date', list.transaction_no) }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="isLoading && (leaveType == 'PanelGroup')" class="group-content-load">

    </div> -->
  </div>

  <!-- Detail modal -->
  <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="relative h-5/6 flex flex-col mx-4 md:mx-0 pb-4 w-11/12 md:w-2/3 lg:w-1/2"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <div class="modal-head">
      <h1>Detail Leave Request</h1>
      <jb-button class="btn-close-modal" :icon="mdiClose" @click="openDetail()" />
    </div>

    <div class="modal-content detail-content" style="background-color: white;">
      <hrreqleave-detail :prop-class="detailData" @close-modal="openDetail()" @refresh-list="refreshData()" />
    </div>
  </vue-final-modal>
</template>

<script>
  /* eslint-disable */
  import { ref, onMounted, onBeforeMount, computed, watchEffect, reactive } from 'vue'
  import { useRouter } from 'vue-router'
  import { mdiClose } from '@mdi/js'
  import axios from 'axios'

  import JbButton from '@/components/JbButton'
  import HrreqleaveDetail from '@/views/humanresource/hrreqleave/Detail'

  export default {
    components: {
      JbButton,
      HrreqleaveDetail
    },

    props: {
      isLoading: { type: Boolean, default: false },
      leaveType: { type: String, default: "" },
      panelData: { type: Object, default: [] },
      panelDatafull: { type: Object, default: [] },
      leaveData: { type: Object, default: [] }
    },

    setup (props, { emit }) {
      const detailModal = ref(false)
      const detailData = ref({})
      const openDetail = (data) => {
        if(!props.leaveData || props.leaveData.length < 1){
          return true
        }

        if(data && props.leaveData) {
          detailData.value = props.leaveData.filter(item => item.id == data.id)[0]
          detailModal.value = true
        } else {
          detailModal.value = false
          detailData.value = {}
        }
      }


      function formatDate(mode, startDateStr, endDateStr = null) {
        const monthsFull = [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ]
        const monthsShort = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
          'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ]
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

        const parseDate = (str) => {
          const [year, month, day] = str.split('-').map(Number)
          return new Date(year, month - 1, day)
        }

        if (mode === 'date') {
          const date = parseDate(startDateStr)
          const dayName = days[date.getDay()]
          const day = date.getDate()
          const month = monthsFull[date.getMonth()]
          const year = date.getFullYear()
          return `${dayName}, ${day} ${month} ${year}`
        }

        if (mode === 'timeline' && endDateStr) {
          const start = parseDate(startDateStr)
          const end = parseDate(endDateStr)

          // Jika tanggalnya sama
          if (
            start.getDate() === end.getDate() &&
            start.getMonth() === end.getMonth() &&
            start.getFullYear() === end.getFullYear()
          ) {
            const day = start.getDate()
            const month = monthsFull[start.getMonth()]
            const year = start.getFullYear()
            return `${day} ${month} ${year}`
          }

          const sameYear = start.getFullYear() === end.getFullYear()
          const sameMonth = sameYear && start.getMonth() === end.getMonth()

          const startDay = start.getDate()
          const endDay = end.getDate()

          const startMonth = sameMonth ? null : monthsShort[start.getMonth()]
          const endMonth = monthsShort[end.getMonth()]

          const startYear = start.getFullYear()
          const endYear = end.getFullYear()

          if (sameYear && sameMonth) {
            return `${startDay}-${endDay} ${endMonth} ${endYear}`
          } else if (sameYear) {
            return `${startDay} ${startMonth} - ${endDay} ${endMonth} ${endYear}`
          } else {
            return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`
          }
        }

        return ''
      }

      function formatTime(start_time, end_time) {
        if (start_time.startsWith("00:00") && end_time.startsWith("23:59")) {
          return ""
        }

        const toTimeString = (timeStr) => {
          const [hour, minute] = timeStr.split(":")
          return `${hour}.${minute}`
        }

        return ` (${toTimeString(start_time)} - ${toTimeString(end_time)})`
      }


      function formatList(data) {
        const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]
        const groupedData = {}

        data.forEach(item => {
          const dateObj = new Date(item.forFormatDate)
          const year = dateObj.getFullYear().toString()
          const monthIndex = dateObj.getMonth()
          const monthName = monthNames[monthIndex]

          if (!groupedData[year]) {
            groupedData[year] = {}
          }


          if (!groupedData[year][monthName]) {
            groupedData[year][monthName] = {
              data: [],
              index: monthIndex
            }
          }

          groupedData[year][monthName].data.push(item)
        })

        const result = Object.entries(groupedData)
        .sort((a, b) => b[0] - a[0])
        .map(([year, months]) => {
          const sortedMonths = Object.entries(months)
            .sort((a, b) => b[1].index - a[1].index)
            .map(([month_name, { data }]) => ({
              month_name,
              data
            }))

          return {
            year,
            month: sortedMonths
          }
        })

        return result
      }

      const openAll = (type, state, data) => {
        emit("open-all", {type, state, data})
      }

      const refreshData = () => {
        openDetail()
        emit("refresh-data")
      }


      watchEffect(() => {

      })

      return {
        mdiClose,
        detailModal,
        detailData,
        openDetail,
        refreshData,
        openAll,
        formatList,
        formatDate,
        formatTime
      }
    }
  }
</script>

<style lang="scss" scoped>
  .approval-leave-content {
    padding-bottom: 12px;

    .header-content {
      width: 100%;
      height: 40px;
      background-color: blue;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      display: flex;
      align-items: center;
      padding: 0 12px;

      p {
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        color: white;
      }
    }

    .list-content {
      width: 100%;
      height: 320px;
      max-height: 320px;
      overflow-y: auto;
      padding: 12px 12px 0 12px;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .list-outer {
        width: 100%;
        height: auto;
        background-color: rgb(255, 250, 237);
        border: 2px solid rgb(255, 235, 184);
        border-radius: 12px;
        padding: 4px 12px;
        cursor: pointer;
        transition: background-color .5s, box-shadow .5s;

        .list-inner-header {
          width: 100%;
          height: auto;
          display: flex;
          flex-wrap: nowrap;
          align-items: center;
          gap: 8px;
          border-bottom: .6px solid gray;
          padding: 2px 0 4px 0;
          margin-bottom: 8px;

          svg {
            width: 12px;
            height: 12px;
          }

          p {
            font-size: 12px;
            line-height: 20px;
            font-weight: 500;
          }
        }

        .list-inner-name {
          font-size: 16px;
          line-height: 26px;
          font-weight: 500;
          margin-bottom: 8px;
        }

        .list-inner-desc {
          font-size: 12px;
          line-height: 20px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .list-inner-date {
          width: 100%;
          margin-top: 8px;
          font-weight: 500;
          font-size: 12px;
          line-height: 20px;
          text-align: right;
        }

        &:hover {
          background-color: rgb(255, 235, 184);
          // box-shadow: 0 0 10px lightgray;
        }
      }

      .list-outer-load {
        width: 100%;
        height: 120px !important;
        background-color: rgb(235, 235, 235);
        border-radius: 12px;
      }

      .list-outer-none {
        width: 100%;
        height: 380px;
        background-color: rgb(235, 235, 235);
        border-radius: 12px;
        font-size: 16px;
        line-height: 24px;
        font-weight: 500;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        text-align: center;
      }
    }

    .list-content-full {
      height: 380px !important;
      max-height: 380px !important;
    }

    .show-content {
      width: 100%;
      height: 60px;
      padding: 16px 12px 0 12px;
      display: flex;
      justify-content: center;

      .show-button {
        width: max-content;
        height: 36px;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        padding: 0 20px;
        cursor: pointer;
        border-radius: 12px;
        background-color: rgb(43, 110, 255);
        border: 2px solid rgb(0, 81, 255);

        p {
          color: white;
          width: 100%;
          text-align: center;
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          position: relative;
          z-index: 5;
        }

        @media (min-width: 480px) {
          &::before {
            content: '';
            width: 0%;
            height: 0%;
            border-radius: 100%;
            position: absolute;
            z-index: 1;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: rgba(255, 255, 255, 0.15);
            transition: width .4s, height .4s, border-radius .4s;
          }

          &:hover {
            &::before {
              width: 200%;
              height: 200%;
              border-radius: 0;
            }
          }
        }
      }
    }
  }


  .leave-content-yellow {
    .header-content {
      background-image: linear-gradient(to bottom right, orangered, orange);

      p {
        color: white;
      }
    }

    .list-content {
      .list-outer {
        background-color: rgb(255, 250, 237);
        border: 2px solid rgb(255, 235, 184);

        &:hover {
          background-color: rgb(255, 235, 184);
        }
      }
    }
  }


  .leave-content-green {
    .header-content {
      background-image: linear-gradient(to bottom right, green, yellowgreen);

      p {
        color: white;
      }
    }

    .list-content {
      .list-outer {
        background-color: rgb(237, 255, 237);
        border: 2px solid rgb(195, 255, 195);

        &:hover {
          background-color: rgb(195, 255, 195);
        }
      }
    }
  }


  .leave-content-red {
    .header-content {
      background-image: linear-gradient(to bottom right, maroon, red);

      p {
        color: white;
      }
    }

    .list-content {
      .list-outer {
        background-color: rgb(255, 237, 237);
        border: 2px solid rgb(255, 192, 185);

        &:hover {
          background-color: rgb(255, 192, 185);
        }
      }
    }
  }
</style>
